import React from 'react';
import RapidLayerAnimation from "../rapidLayerComponents/RapidLayerAnimation";

export default function Home() {
  return (
    <>
    <RapidLayerAnimation/>
    </>
  )
}
